var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-search",class:{'seachIptGrayStyle' : _vm.seachIptGray}},[_c('van-search',{attrs:{"placeholder":_vm.placeholder},on:{"search":_vm.handleSearch,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"clear":_vm.handleClear},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }